<template>
<div class="d-flex flex-nowrap align-items-center px-1 py-2">
	<pick-period-vidget
		class="px-2"
		:tiles="new Array(
			['24 год', 1],
			['7 днів', 7],
			['30 днів', 30],
			['90 днів', 90],
			['1 рік', 365],
		)"
		@period="(from, to) => {
			timeFrom = dayStart(from)
			timeTo = dayEnd(to)
		}"
		:disabled="isLoading"
	/>

	<div class="px-0 d-flex align-items-center">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm m-0 rounded-circle"
			@click="showAbout = true"
			style="border: 0px;"
		>
			<button-icon icon="question" fill="currentColor"/>
		</button>
	</div>
</div>

<div class="row m-0 mx-1 p-0">
	<alerts-table
		:time-from="timeFrom"
		:time-to="timeTo"
	/>
</div>

<!-- About pop-up -->
<pop-up-modal
	v-model:show="showAbout"
	size="modal-xl"
	title="Як користуватись таблицею сповіщень"
	rejectButtonTitle="Закрити"
	@reject="showAbout = false"
>
	<template v-slot:body>
		<all-alerts-section-about />
	</template>
</pop-up-modal>
</template>


<script>
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import PickPeriodVidget from '@/components/Vidgets/PickPeriodVidget.vue'
import ButtonIcon from '@/components/Icons/ButtonIcon.vue'
import PopUpModal from '@/components/PopUpModal.vue'
import AllAlertsSectionAbout from './AllAlertsSectionAbout.vue'
import AlertsTable from './AlertsTable.vue'
import { dayStart, dayEnd, } from '@/helpers.js'


export default {
	components: {
		PickPeriodVidget,
		ButtonIcon,
		PopUpModal,
		AllAlertsSectionAbout,
		AlertsTable,
	},

	props: {},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()

		return {
			dayStart,
			dayEnd,
			accountStore,
			stationsStore,
		}
	},

	data() {
		return {
			timeFrom: new Date(),
			timeTo: new Date(),
			showAbout: false,
		}
	},

	async created() {
		if (this.stationsStore.isNoStations) {
			// Read all stations for station IDs list load
			await this.stationsStore.readStations()
		}
	},

	mounted() {
		document.title = "Сповіщення"
	},

	methods: {},

	computed: {},
}
</script>


<style scoped>
</style>